import { render } from "./CoachForm.vue?vue&type=template&id=2806d391&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=2806d391&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2806d391"

export default script